<template>
	<div class="h5-chat-page">
<!--		<div class="h5-header">-->
<!--			<span class="h5-header-btn el-icon-arrow-left" @click="onBack"></span>-->
<!--			<span class="h5-header-title">{{ title }}</span>-->
<!--			<span class="h5-header-btn el-icon-menu" @click="drawerVisible = true"></span>-->
<!--		</div>-->

		<div class="h5-chat-body" v-if="activeConv">
			<chat-box :conversation="activeConv"></chat-box>
		</div>
		<div class="h5-empty" v-else>
			<div class="h5-empty-box">
				<span v-if="initializing" class="el-icon-loading h5-empty-icon"></span>
				<span class="h5-empty-text">{{ initializing ? '正在加载...' : '暂无好友，无法发起聊天' }}</span>
			</div>
		</div>

		<el-drawer title="好友列表" :visible.sync="drawerVisible" direction="ltr" size="80%" :wrapperClosable="true">
			<div class="friend-list">
				<div v-for="f in friends" :key="f.id"
					:class="['friend-row', { active: f.id === activeFriendId }]" @click="onSwitchFriend(f)">
					<head-image :name="f.nickName" :url="f.headImage" :size="40" :online="f.online" :isShowUserInfo="false">
					</head-image>
					<span class="friend-nick">{{ f.nickName }}</span>
				</div>
				<div v-if="!friends.length" class="friend-empty">暂无好友</div>
			</div>
		</el-drawer>

		<full-image ref="fullImage"></full-image>
	</div>
</template>

<script>
import ChatBox from '../components/chat/ChatBox.vue';
import FullImage from '../components/common/FullImage.vue';
import HeadImage from '../components/common/HeadImage.vue';
import * as auth from '../api/auth.js';

export default {
	name: 'h5Chat',
	components: {
		ChatBox,
		FullImage,
		HeadImage
	},
	data() {
		return {
			initializing: true,
			drawerVisible: false,
			activeFriendId: null,
			privateMessagesBuffer: [], // 拉取离线消息期间缓存的实时私聊消息，防止乱序
			reconnecting: false,
			lastPlayAudioTime: new Date().getTime() - 1000
		}
	},
	computed: {
		friends() {
			return this.friendStore.friends || [];
		},
		activeFriend() {
			return this.friendStore.findFriend(this.activeFriendId) || {};
		},
		activeConv() {
			return this.chatStore.activeConversation;
		},
		mine() {
			return this.userStore.userInfo;
		},
		title() {
			return this.activeFriend.nickName || '聊天';
		}
	},
	methods: {
		/* ============ 登录（从 ShenbaoLogin 同步：已登录直接放行 / userUid 静默免登 / refreshToken 自动登录） ============ */
		async ensureLogin() {
			// 已登录直接放行
			if (auth.isLoggedIn()) {
				return;
			}
			// 1) 深报 userUid 静默免登
			const userUid = this.$route.query.userUid;
			if (userUid) {
				const data = await this.$http({
					url: "/shenbaoLogin",
					method: 'post',
					data: { userUid }
				});
				auth.saveLoginSession(data, {
					autoLogin: auth.isAutoLoginEnabled(),
					userName: auth.getSavedUsername()
				});
				this.$message.success("登录成功");
				return;
			}
			// 2) 本地 refreshToken 自动登录
			if (auth.isAutoLoginEnabled()) {
				try {
					await auth.refreshLogin();
					return;
				} catch (e) {
					auth.clearLoginSession(true);
					throw e;
				}
			}
			// 3) 无任何登录凭证
			throw new Error('未登录且无可用登录凭证');
		},
		/* ============ 初始化（复刻 Home.vue，精简为私聊场景） ============ */
		async loadStore() {
			await this.userStore.loadUser();
			await this.$db.open(this.userStore.userInfo.id);
			// 加载好友要在加载会话前面，否则好友在线状态不显示
			await this.friendStore.loadFriend();
			const promises = [];
			promises.push(this.groupStore.loadGroup()); // 保留：chatStore.refreshDnd 会遍历群
			promises.push(this.configStore.loadConfig());
			promises.push(this.chatStore.loadConversations());
			return Promise.all(promises);
		},
		pullOfflineMessage() {
			let timeStamp = new Date().getTime();
			this.chatStore.setLoading(true);
			const promises = [];
			const maxPrivateMessageId = this.chatStore.findMaxMessageId(this.$enums.CONVERSATION_TYPE.PRIVATE);
			const maxGroupMessageId = this.chatStore.findMaxMessageId(this.$enums.CONVERSATION_TYPE.GROUP);
			promises.push(this.pullPrivateOfflineMessage(maxPrivateMessageId));
			promises.push(this.pullGroupOfflineMessage(maxGroupMessageId));
			Promise.all(promises).then(async (messages) => {
				// 处理离线消息（群离线也入库，保证 seqNo 连续与 dnd 状态一致，但不打开群会话）
				await this.handlePrivateOfflineMessage(messages[0]);
				await this.handleGroupOfflineMessage(messages[1]);
				// 处理缓冲区收到的实时私聊消息
				for (const m of this.privateMessagesBuffer) {
					await this.handlePrivateMessage(m);
				}
				this.privateMessagesBuffer = [];
				this.chatStore.setLoading(false);
				let size = messages[0].length + messages[1].length;
				let time = new Date().getTime() - timeStamp;
				console.log("H5 加载离线消息耗时:", time, ",消息数量:", size);
				// 离线就绪后，默认选中第一个好友发起聊天
				await this.openFirstFriend();
				this.initializing = false;
			}).catch((e) => {
				console.log(e);
				this.$message.error("拉取离线消息失败");
				this.onExit();
			});
		},
		async handlePrivateOfflineMessage(messages) {
			if (!messages || !messages.length) {
				return;
			}
			const conversationMap = new Map();
			const messageMap = new Map(messages.map(m => [m.id, m]));
			const tmpMessages = [];
			for (const m of messages) {
				m.selfSend = m.sendId == this.mine.id;
				const friendId = m.selfSend ? m.recvId : m.sendId;
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friendId);
				m.convKey = convKey;
				let conversation = conversationMap.get(friendId);
				if (!conversation) {
					conversation = await this.$db.findConversationByKey(convKey);
					if (!conversation) {
						const friend = this.loadFriendInfo(friendId);
						conversation = {
							key: convKey,
							type: this.$enums.CONVERSATION_TYPE.PRIVATE,
							targetId: friend.id,
							showName: friend.nickName,
							headImage: friend.headImage,
							isDnd: friend.isDnd,
							isTop: false,
							lastContent: "",
							lastSendTime: new Date().getTime(),
							optTime: new Date().getTime(),
							unreadCount: 0,
							lastTimeTip: 0,
							maxMessageId: 0,
							minSeqNo: 0,
							maxSeqNo: 0,
							maxReadedId: 0
						}
					}
					conversationMap.set(friendId, conversation);
				}
				conversation.lastSendTime = m.sendTime;
				conversation.optTime = m.sendTime;
				conversation.maxMessageId = Math.max(conversation.maxMessageId, m.id)
				conversation.maxSeqNo = Math.max(conversation.maxSeqNo, m.seqNo)
				if (!m.selfSend && m.status != this.$enums.MESSAGE_STATUS.READED &&
					m.status != this.$enums.MESSAGE_STATUS.RECALL && m.type != this.$enums.MESSAGE_TYPE.TIP_TEXT) {
					conversation.unreadCount++;
				}
				if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
					const recallMessageId = Number(JSON.parse(m.content).id);
					const recallMessageTip = JSON.parse(m.content).tip || '';
					let recallMessage = messageMap.get(recallMessageId);
					if (!recallMessage) {
						recallMessage = await this.$db.findMessageById(convKey, recallMessageId);
						if (!recallMessage) {
							continue;
						}
						tmpMessages.push(recallMessage);
					}
					recallMessage.status = this.$enums.MESSAGE_STATUS.PENDING;
					recallMessage.content = recallMessageTip;
					recallMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
					conversation.lastContent = this.$msgUtil.previewContent(recallMessage);
					conversation.sendNickName = "";
				} else {
					conversation.lastContent = this.$msgUtil.previewContent(m);
				}
			}
			const conversations = Array.from(conversationMap.values());
			await this.$db.saveConversationAndMessage(conversations, messages.concat(tmpMessages));
			this.chatStore.append(conversations);
		},
		async handleGroupOfflineMessage(messages) {
			if (!messages || !messages.length) {
				return;
			}
			const conversationMap = new Map();
			const messageMap = new Map(messages.map(m => [m.id, m]));
			const tmpMessages = [];
			for (const m of messages) {
				m.selfSend = m.sendId == this.mine.id;
				const groupId = m.groupId;
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, groupId);
				m.convKey = convKey;
				let conversation = conversationMap.get(groupId);
				if (!conversation) {
					conversation = await this.$db.findConversationByKey(convKey);
					if (!conversation) {
						const group = this.loadGroupInfo(groupId);
						conversation = {
							key: convKey,
							type: this.$enums.CONVERSATION_TYPE.GROUP,
							targetId: group.id,
							showName: group.showGroupName,
							headImage: group.headImageThumb,
							isDnd: group.isDnd,
							isTop: false,
							lastContent: "",
							lastSendTime: new Date().getTime(),
							optTime: new Date().getTime(),
							unreadCount: 0,
							atMe: false,
							atAll: false,
							lastAtMessageId: -1,
							lastTimeTip: 0,
							maxMessageId: 0,
							minSeqNo: 0,
							maxSeqNo: 0,
							maxReadedId: 0
						}
					}
					conversationMap.set(groupId, conversation);
				}
				conversation.lastSendTime = m.sendTime;
				conversation.optTime = m.sendTime;
				conversation.maxMessageId = Math.max(conversation.maxMessageId, m.id);
				conversation.maxSeqNo = Math.max(conversation.maxSeqNo, m.seqNo)
				if (!m.selfSend && m.status != this.$enums.MESSAGE_STATUS.READED &&
					m.status != this.$enums.MESSAGE_STATUS.RECALL && m.type != this.$enums.MESSAGE_TYPE.TIP_TEXT) {
					conversation.unreadCount++;
				}
				if (!m.selfSend && m.atUserIds && m.status != this.$enums.MESSAGE_STATUS.READED) {
					const userId = this.mine.id;
					if (m.atUserIds.indexOf(userId) >= 0) {
						conversation.atMe = true;
						conversation.lastAtMessageId = m.id;
					}
					if (m.atUserIds.indexOf(-1) >= 0) {
						conversation.atAll = true;
						conversation.lastAtMessageId = m.id;
					}
				}
				if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
					const recallMessageId = Number(JSON.parse(m.content).id);
					const recallMessageTip = JSON.parse(m.content).tip || '';
					let recallMessage = messageMap.get(recallMessageId);
					if (!recallMessage) {
						recallMessage = await this.$db.findMessageById(convKey, recallMessageId);
						if (!recallMessage) {
							continue;
						}
						tmpMessages.push(recallMessage);
					}
					recallMessage.status = this.$enums.MESSAGE_STATUS.PENDING;
					recallMessage.content = recallMessageTip;
					recallMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
					conversation.lastContent = this.$msgUtil.previewContent(recallMessage);
					conversation.sendNickName = "";
				} else {
					conversation.lastContent = this.$msgUtil.previewContent(m);
					conversation.sendNickName = m.selfSend ? '' : m.sendNickName;
				}
			}
			const conversations = Array.from(conversationMap.values());
			await this.$db.saveConversationAndMessage(conversations, messages.concat(tmpMessages));
			this.chatStore.append(conversations);
		},
		pullPrivateOfflineMessage(minId) {
			return this.$http({
				url: "/message/private/loadOfflineMessage?minId=" + minId
			})
		},
		pullGroupOfflineMessage(minId) {
			return this.$http({
				url: "/message/group/loadOfflineMessage?minId=" + minId
			})
		},
		/* ============ 实时消息分发 ============ */
		onWsMessage(cmd, message) {
			if (cmd == 2) {
				// 强制下线
				this.$wsApi.close(3000);
				this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
					confirmButtonText: '确定',
					callback: () => {
						location.href = "/";
					}
				});
			} else if (cmd == 3) {
				if (this.chatStore.loading) {
					// 拉取离线消息期间先缓存，防止乱序
					this.privateMessagesBuffer.push(message);
				} else {
					this.handlePrivateMessage(message);
				}
			} else if (cmd == 4) {
				// H5 不展示群会话，实时群消息丢弃（群离线已补齐历史）
			} else if (cmd == 5) {
				this.handleSystemMessage(message);
			}
		},
		async handlePrivateMessage(m) {
			m.selfSend = m.sendId == this.mine.id;
			const friendId = m.selfSend ? m.recvId : m.sendId;
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friendId);
			// 消息已读处理，清空已读数量
			if (m.type == this.$enums.MESSAGE_TYPE.READED) {
				await this.chatStore.resetUnreadCount(convKey)
				return;
			}
			// 消息回执处理,改消息状态为已读
			if (m.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				await this.chatStore.readedMessage(convKey)
				return;
			}
			// 消息撤回
			if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
				await this.chatStore.recallMessage(convKey, m)
				return;
			}
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.friendStore.addFriend(JSON.parse(m.content));
				return;
			}
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.friendStore.removeFriend(friendId);
				return;
			}
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
				this.friendStore.updateOnlineStatus(JSON.parse(m.content));
				return;
			}
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
				this.friendStore.setDnd(friendId, JSON.parse(m.content));
				await this.chatStore.setDnd(convKey, JSON.parse(m.content));
				return;
			}
			// H5 不支持音视频，单人通话信令静默丢弃
			if (this.$msgType.isRtcPrivate(m.type)) {
				return;
			}
			// 普通消息插入
			if (this.$msgType.isNormal(m.type) || this.$msgType.isTip(m.type) || this.$msgType.isAction(m.type)) {
				const friend = this.loadFriendInfo(friendId);
				await this.insertPrivateMessage(friend, m);
			}
		},
		async insertPrivateMessage(friend, m) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id);
			const chatInfo = {
				type: this.$enums.CONVERSATION_TYPE.PRIVATE,
				targetId: friend.id,
				showName: friend.nickName,
				headImage: friend.headImage,
				isDnd: friend.isDnd
			};
			await this.chatStore.openChat(chatInfo);
			await this.chatStore.insertMessage(convKey, m);
			// 通知 chat-box 组件滚到底部
			if (this.chatStore.isActive(convKey)) {
				this.$eventBus.$emit("newMessage", m);
			}
			// 播放提示音
			if (!friend.isDnd && !m.selfSend && this.$msgType.isNormal(m.type)
				&& m.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
			}
		},
		handleSystemMessage(msg) {
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: () => {
						this.onExit();
					}
				});
			}
		},
		/* ============ 默认选第一个好友 + 切换 ============ */
		async openFirstFriend() {
			// 已有活跃会话（如刷新恢复）则不覆盖
			if (this.activeConv) {
				return;
			}
			const list = (this.friendStore.friends || []).filter(f => !f.deleted);
			if (!list.length) {
				return;
			}
			await this.selectFriend(list[0]);
		},
		async selectFriend(friend) {
			this.activeFriendId = friend.id;
			const chatInfo = {
				type: this.$enums.CONVERSATION_TYPE.PRIVATE,
				targetId: friend.id,
				showName: friend.nickName,
				headImage: friend.headImage,
				isDnd: friend.isDnd
			};
			// 打开/创建会话并入库
			await this.chatStore.openChat(chatInfo);
			// 设为当前会话，触发 ChatBox 重新加载该会话消息
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id);
			this.chatStore.setActive(convKey);
			this.drawerVisible = false;
		},
		onSwitchFriend(friend) {
			if (!friend || friend.id === this.activeFriendId) {
				this.drawerVisible = false;
				return;
			}
			this.selectFriend(friend);
		},
		/* ============ 断线重连 ============ */
		reconnectWs() {
			this.reconnecting = true;
			this.userStore.loadUser().then(() => {
				this.$message.error("连接断开，正在尝试重新连接...");
				this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
			}).catch(() => {
				setTimeout(() => this.reconnectWs(), 10000)
			})
		},
		onReconnectWs() {
			this.reconnecting = false;
			const promises = [];
			promises.push(this.friendStore.loadFriend());
			promises.push(this.groupStore.loadGroup());
			Promise.all(promises).then(() => {
				this.pullOfflineMessage();
				this.$message.success("重新连接成功");
			}).catch(() => {
				this.$message.error("初始化失败");
				this.onExit();
			})
		},
		/* ============ 工具方法 ============ */
		loadFriendInfo(id) {
			let friend = this.friendStore.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					nickName: "未知用户",
					headImage: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.groupStore.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "未知群聊",
					headImageThumb: ""
				}
			}
			return group;
		},
		playAudioTip() {
			// 防止过于密集播放
			if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
				this.lastPlayAudioTime = new Date().getTime();
				let audio = new Audio();
				let url = require(`@/assets/audio/tip.mp3`);
				audio.src = url;
				audio.play();
			}
		},
		/* ============ 退出 / 清理 ============ */
		unloadStore() {
			this.friendStore.clear();
			this.groupStore.clear();
			this.chatStore.clear();
			this.userStore.clear();
		},
		onExit() {
			this.unloadStore();
			this.$wsApi.close(3000);
			auth.clearLoginSession(true);
			this.$elm.setTitleTip("");
			this.$db.close();
			location.href = "/";
		},
		onBack() {
			this.onExit();
		}
	},
	mounted() {
		// ChatBox 内点图片全屏需要宿主页面响应
		this.$eventBus.$on('openFullImage', url => {
			this.$refs.fullImage && this.$refs.fullImage.open(url);
		});
		// 先确保已登录（静默/自动登录），再加载会话数据并连接 ws
		this.ensureLogin().then(() => {
			return this.loadStore();
		}).then(() => {
			// ws 初始化
			this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
			this.$wsApi.onConnect(() => {
				if (this.reconnecting) {
					this.onReconnectWs();
				} else {
					this.pullOfflineMessage();
				}
			});
			this.$wsApi.onMessage((cmd, message) => {
				this.onWsMessage(cmd, message);
			});
			this.$wsApi.onClose((e) => {
				if (e.code != 3000 && !this.reconnecting) {
					this.reconnectWs();
				}
			});
		}).catch((e) => {
			console.log("H5 登录/初始化失败", e);
			// 未登录且无可用凭证，回退到深报登录页
			this.$router.replace("/shenbaologin");
		});
	},
	unmounted() {
		this.$eventBus.$off('openFullImage');
		this.$wsApi.close();
	}
}
</script>

<style scoped lang="scss">
.h5-chat-page {
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	background: #f4f5f6;
	overflow: hidden;
}

.h5-header {
	height: 50px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 8px;
	padding-top: env(safe-area-inset-top);
	background: var(--im-color-primary);
	color: #fff;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
	z-index: 10;

	.h5-header-btn {
		width: 40px;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 22px;
		cursor: pointer;
	}

	.h5-header-title {
		flex: 1;
		text-align: center;
		font-size: 16px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}

.h5-chat-body {
	flex: 1;
	min-height: 0;
	width: 100%;
	overflow: hidden;
	position: relative;

	// 让 ChatBox 撑满容器
	:deep(.chat-box) {
		width: 100%;
		height: 100%;
	}

	:deep(.chat-box .el-container) {
		height: 100%;
	}

	// 输入区高度（桌面端 220px 偏高）
	:deep(.im-chat-footer) {
		height: 160px !important;
	}

	// 工具栏精简：隐藏文件传输、音视频通话、群回执等
	:deep(.chat-tool-bar > div[title="发送文件"]),
	:deep(.chat-tool-bar > div[title="回执消息"]),
	:deep(.chat-tool-bar > div[title="语音通话"]),
	:deep(.chat-tool-bar > div[title="多人通话"]),
	:deep(.chat-tool-bar > div[title="视频通话"]) {
		display: none !important;
	}
}

.h5-empty {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;

	.h5-empty-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}

	.h5-empty-icon {
		font-size: 30px;
		color: var(--im-text-color-light);
	}

	.h5-empty-text {
		font-size: 14px;
		color: var(--im-text-color-light);
	}
}

.friend-list {
	.friend-row {
		display: flex;
		align-items: center;
		padding: 10px 16px;
		gap: 12px;
		cursor: pointer;
		transition: background 0.15s;

		&:active,
		&.active {
			background: var(--im-background-active);
		}

		.friend-nick {
			flex: 1;
			font-size: 15px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}

	.friend-empty {
		text-align: center;
		color: #999;
		padding: 40px 0;
		font-size: 14px;
	}
}
</style>

<!-- 非 scoped 块：ChatMessageItem.vue / ChatInput.vue 的样式无 scoped（全局），需用 .h5-chat-body 前缀覆盖 -->
<style lang="scss">
.h5-chat-page {
	// 收窄消息气泡两侧 padding（桌面端 300px/180px 在窄屏会把气泡挤没）
	.chat-message-item {
		.message-normal:not(.message-mine) .content .message-bottom {
			padding-right: 24% !important;
		}

		.message-normal.message-mine .content .message-bottom {
			padding-left: 24% !important;
		}

		// 长按消息时禁用系统的文字选择/呼出菜单，避免与自定义菜单冲突
		.message-bottom {
			-webkit-touch-callout: none;
			-webkit-user-select: none;
			user-select: none;
		}
	}

	// iOS 下 contenteditable 字号 <16px 会自动缩放页面
	[contenteditable="true"] {
		font-size: 16px !important;
	}
}
</style>
